// DRC - Sn Screen
export const drcSnData = {
  location: 'DRC',
  mineral: 'Sn',
  totalExportsTillDate: { amount: 48.12, unit: 'K', tonnes: 48.12 },
  totalExportThisMonth: { amount: 67, unit: 'M', tonnes: 300 },
  totalExportYTD: { amount: 67, unit: 'M', tonnes: 300 },
  currentStock: { amount: 67, unit: 'M', tonnes: 300 },
  purchasesThisWeek: { amount: 15, unit: '', tonnes: 300 },
  purchasesThisMonth: { amount: 6, unit: '', tonnes: 300 },
  purchasesYTD: { amount: 200, unit: 'K', tonnes: 300 },
  containersInTransit: {
    inTransit: { count: 67, weight: 25 },
    delivered: { count: 20, weight: 10 },
    delayed: { count: 3, weight: 5 }
  },
  inventoryByComptoir: [
    { name: 'BASEMIN', quantity: 2125 },
    { name: 'LUMA', quantity: 1256 },
    { name: 'LIMC', quantity: 1111 },
    { name: 'MAWEX', quantity: 1111 }
  ],
  liveActivity: [
    { message: 'New export ready #Export BSM 00212 4545554...', time: '3m ago' }
  ]
};

// DRC - Ta Screen
export const drcTaData = {
  location: 'DRC',
  mineral: 'Ta',
  totalExportsTillDate: { amount: 32.45, unit: 'K', tonnes: 32.45 },
  totalExportThisMonth: { amount: 45, unit: 'M', tonnes: 250 },
  totalExportYTD: { amount: 45, unit: 'M', tonnes: 250 },
  currentStock: { amount: 45, unit: 'M', tonnes: 250 },
  purchasesThisWeek: { amount: 12, unit: '', tonnes: 250 },
  purchasesThisMonth: { amount: 5, unit: '', tonnes: 250 },
  purchasesYTD: { amount: 180, unit: 'K', tonnes: 250 },
  containersInTransit: {
    inTransit: { count: 45, weight: 18 },
    delivered: { count: 15, weight: 8 },
    delayed: { count: 2, weight: 3 }
  },
  inventoryByComptoir: [
    { name: 'BASEMIN', quantity: 1800 },
    { name: 'LUMA', quantity: 1100 },
    { name: 'LIMC', quantity: 950 },
    { name: 'MAWEX', quantity: 900 }
  ],
  liveActivity: [
    { message: 'New export ready #Export BSM 00212 4545554...', time: '3m ago' }
  ]
};

// Rwanda - Sn Screen
export const rwandaSnData = {
  location: 'RWANDA',
  mineral: 'Sn',
  totalExportsTillDate: { amount: 55.78, unit: 'K', tonnes: 55.78 },
  totalExportThisMonth: { amount: 72, unit: 'M', tonnes: 320 },
  totalExportYTD: { amount: 72, unit: 'M', tonnes: 320 },
  currentStock: { amount: 72, unit: 'M', tonnes: 320 },
  purchasesThisWeek: { amount: 18, unit: '', tonnes: 320 },
  purchasesThisMonth: { amount: 7, unit: '', tonnes: 320 },
  purchasesYTD: { amount: 220, unit: 'K', tonnes: 320 },
  containersInTransit: {
    inTransit: { count: 72, weight: 28 },
    delivered: { count: 25, weight: 12 },
    delayed: { count: 4, weight: 6 }
  },
  inventoryByLocation: [
    { name: 'With RMR', quantity: 2300 },
    { name: 'With Minexx', quantity: 1400 },
    { name: 'Pending Shipment', quantity: 1200 }
  ],
  liveActivity: [
    { message: 'New export ready #Export BSM 00212 4545554...', time: '3m ago' }
  ]
};

// Rwanda - Ta Screen
export const rwandaTaData = {
  location: 'RWANDA',
  mineral: 'Ta',
  totalExportsTillDate: { amount: 41.23, unit: 'K', tonnes: 41.23 },
  totalExportThisMonth: { amount: 56, unit: 'M', tonnes: 270 },
  totalExportYTD: { amount: 56, unit: 'M', tonnes: 270 },
  currentStock: { amount: 56, unit: 'M', tonnes: 270 },
  purchasesThisWeek: { amount: 14, unit: '', tonnes: 270 },
  purchasesThisMonth: { amount: 5, unit: '', tonnes: 270 },
  purchasesYTD: { amount: 190, unit: 'K', tonnes: 270 },
  containersInTransit: {
    inTransit: { count: 56, weight: 22 },
    delivered: { count: 18, weight: 9 },
    delayed: { count: 3, weight: 4 }
  },
  inventoryByLocation: [
    { name: 'With RMR', quantity: 1950 },
    { name: 'With Minexx', quantity: 1200 },
    { name: 'Pending Shipment', quantity: 980 }
  ],
  liveActivity: [
    { message: 'New export ready #Export BSM 00212 4545554...', time: '3m ago' }
  ]
};

// Keep backward compatibility exports
export const drcData = drcSnData;
export const rwandaData = rwandaSnData;